export default __webpack_public_path__ + "static/media/map.4ca43087.png";